export default __webpack_public_path__ + "static/media/nodejs.59c00966.svg";